import React from 'react';
import { useIsIOS } from '@/hooks/useIsIOS';

interface IPadWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const IPadWrapper: React.FC<IPadWrapperProps> = ({ children, className = '' }) => {
  const { isIPad, screenSize, orientation } = useIsIOS();

  if (!isIPad) {
    return <>{children}</>;
  }

  // Classes base para iPad
  const baseClasses = 'ipad-optimized';
  
  // Classes específicas por tamanho de tela
  const sizeClasses = {
    small: 'ipad-small',
    medium: 'ipad-medium', 
    large: 'ipad-large'
  };
  
  // Classes específicas por orientação
  const orientationClasses = {
    portrait: 'ipad-portrait',
    landscape: 'ipad-landscape'
  };

  const combinedClasses = [
    baseClasses,
    sizeClasses[screenSize],
    orientationClasses[orientation],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={combinedClasses} data-ipad-size={screenSize} data-ipad-orientation={orientation}>
      {children}
    </div>
  );
};

export default IPadWrapper; 